import React from 'react';
import Styles from './manage-classes-styles.scss';
import { ButtonKVBase, InputSearchBase, TabHeader, Table } from '@/presentation/components';
import { IconShare } from '@/presentation/components/icons';
import UseManageClasses from './hooks/use-manage-classes';
import TableNotFound from '@/presentation/components/table/table-not-found/table-not-found';
import { manageClassesState } from './components/atoms';
import { useRecoilState } from 'recoil';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import AddClassModal from './components/add-class-modal/add-class-modal';
import { Container } from 'react-bootstrap';
import { SelectFilter } from '../manage-teachers/components';
import { debounce } from 'lodash';
const ManageClasses = ({ loadClassesPaginated, manageClasses, loadUsers }) => {
    const { columns, columnsWithoutSort, getClassesPaginated, renderCellByType } = UseManageClasses(loadClassesPaginated, loadUsers, Styles);
    const [state, setState] = useRecoilState(manageClassesState);
    const { getIdClient } = useUserSesssion();
    const handleOnSearch = debounce((event) => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { filters: {
                    input: event.target.value
                } });
        });
    }, 500);
    const DataNotFoundComp = () => {
        return (React.createElement(TableNotFound, { onClick: () => {
                setState(prev => {
                    return Object.assign(Object.assign({}, prev), { filters: {
                            input: '',
                            deleted: false
                        }, dataNotFound: false });
                });
            }, term: state.filters.input !== '' ? state.filters.input : null }));
    };
    const onAddClass = () => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isAddClassModalVisible: true });
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { className: Styles.mainWrap, fluid: true },
            React.createElement(TabHeader, { icon: React.createElement(IconShare, null), title: "Manage Classes" },
                React.createElement(InputSearchBase, { loading: state.isTableLoading, placeholder: "Search...", onChange: handleOnSearch }),
                React.createElement(SelectFilter, { name: "selectedGradeId", state: state, setState: setState, placeholder: 'All Grades', onChange: e => setState(prev => {
                        return Object.assign(Object.assign({}, prev), { filters: {
                                selectedGradeId: (e === null || e === void 0 ? void 0 : e.value) ? e === null || e === void 0 ? void 0 : e.value : ''
                            } });
                    }), options: state.grades.map(item => ({
                        value: `${item.key}`,
                        label: `${item.value}`
                    })) }),
                React.createElement(ButtonKVBase, { type: "button", width: 99, btnWrapClass: Styles.btnWrapClass, onClick: onAddClass, btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)" }, "Add Class")),
            React.createElement(Table, { columns: columns, data: state.classes.data, dataNotFound: state.dataNotFound, DataNotFoundComponent: () => {
                    return React.createElement(DataNotFoundComp, null);
                }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                    total: state.classes.total,
                    page: state.classes.page,
                    count: state.classes.count,
                    pageCount: state.classes.pageCount
                }, fetchData: (pagination, sort) => {
                    getClassesPaginated(state.filters, pagination, sort);
                }, filters: state.filters, loading: state.isTableLoading })),
        React.createElement(AddClassModal, { manageClasses: manageClasses, idClient: getIdClient() })));
};
export default ManageClasses;
